import DetailsComponent from "./components/DetailsComponent";
import React, { useEffect } from "react";

import { AcceptancePage } from "@hubcapp/layouts";
import { Brand } from "@ds-developer/models";
import { useQueryForAcceptanceData } from "./hooks";
import useQueryGetDDIDocumentUrl from "./hooks/useQueryGetDDIDocumentUrl";

type Props = {
  agreementKey: string;
};

const AcceptancePageStateProvider: React.FC<Props> = ({ agreementKey }) => {
  const [isError, setIsError] = React.useState(false);
  const {
    data,
    refetch: refetchAcceptanceDataHandler,
  } = useQueryForAcceptanceData({
    agreementKey,
    onError: () => {
      localStorage.removeItem("instructorAuth");
      setIsError(true);
    },
  });
  const { data: ddiUrl } = useQueryGetDDIDocumentUrl();
  useEffect(() => {
    const brand =
      data?.franchiseAgreement?.brand === "BSM" ? Brand.Bsm : Brand.Aad;
    if (brand === Brand.Bsm) {
      document.documentElement.style.setProperty("--brand-font", "Poppins");
    } else {
      document.documentElement.style.setProperty(
        "--brand-font",
        "New Transport AA",
      );
    }
  }, [data]);
  if (isError) {
    return (
      <>
        Sorry, your session has expired! Please follow the link in the email
        again.
      </>
    );
  }
  if (!data) {
    return <>Loading...</>;
  }
  return (
    <AcceptancePage
      brand={data.franchiseAgreement.brand === "BSM" ? Brand.Bsm : Brand.Aad}
    >
      <DetailsComponent
        ddiUrl={ddiUrl?.getDDIDocumentUrl}
        data={data.franchiseAgreement}
        agreementKey={agreementKey}
        refetch={refetchAcceptanceDataHandler}
      />
    </AcceptancePage>
  );
};

export default AcceptancePageStateProvider;
